import React, { Dispatch, SetStateAction } from 'react'
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { BasicButton } from '../../widgets/components/UI/BasicButton'

export const RequestFileStatusModal = ({
  headingMessage,
  description,
  showFileStatusModal,
  setFileStatusModal,
}: {
  showFileStatusModal: boolean
  setFileStatusModal: Dispatch<SetStateAction<boolean>>
  headingMessage: string
  description: string
}) => {
  const { formatMessage } = useIntl()

  return (
    <Modal
      show={showFileStatusModal}
      onHide={() => setFileStatusModal(false)}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <h2>{formatMessage({ id: headingMessage })}</h2>
      </Modal.Header>
      <Modal.Body>
        <p>
          {formatMessage({
            id: description,
          })}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <BasicButton
          height='44px'
          border='none'
          color='#F5F8FA'
          textColor='#7E8299'
          padding='12px 16px'
          onClick={() => {
            setFileStatusModal(false)
          }}
          buttonText='Cancel'
          minWidth={56}
        />
      </Modal.Footer>
    </Modal>
  )
}
